import { render, staticRenderFns } from "./configs-data.vue?vue&type=template&id=7ddc34cc"
import script from "./configs-data.vue?vue&type=script&lang=js"
export * from "./configs-data.vue?vue&type=script&lang=js"
import style0 from "./configs-data.vue?vue&type=style&index=0&id=7ddc34cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports